module.exports = __webpack_public_path__ + "media/images/card-img--f8a4fc85.png";